import React from "react";
import { Alert } from "react-bootstrap";

const NoRecordFound = ({message, height}) => {
  return (
    <Alert variant="warning"style={{height:height}} className="d-flex justify-content-center">
      {message}
    </Alert>
  );
};

export default NoRecordFound;